import HashMap from 'hashmap'
import { degrees, PDFDocument, rgb } from 'pdf-lib'
import { getBase64 } from './FileReader'
const drawImages = async (pdfDoc, images) => {
  for await (const image of images) {
    //draw every image from the array
    const url = image.imgUrl
    const targetedImage = image.type === 'png' ? await pdfDoc.embedPng(url) : await pdfDoc.embedJpg(url)
    pdfDoc.getPages()[image.pageNumber - 1].drawImage(targetedImage, {
      x: (image.imgLeft - image.offsetLeft) * image.multiplier, //(left- offsetleft) x multiplier
      y: (image.pageHeight - (image.imgTop - image.offsetTop) - image.imgHeight) * image.multiplier, //(pageheight - (top - offsettop) - height) x multiplier
      width: image.imgWidth * image.multiplier, //width x multiplier
      height: image.imgHeight * image.multiplier, //height x multiplier
      rotate: degrees(image.angle), // angle
    })
  }
}
const drawTexts = async (pdfDoc, textboxes) => {
  const HORIZONTAL_PADDING = 4
  const VERTICAL_PADDING_LIST = new HashMap([
    [10, 8],
    [20, 3],
    [30, -7],
    [40, -17],
    [50, -27],
  ])
  for await (const textbox of textboxes) {
    //draw every textbox from the array
    const font = await pdfDoc.embedFont(textbox.font)
    pdfDoc.getPages()[textbox.pageNumber - 1].drawText(textbox.value, {
      x: (textbox.tbLeft - textbox.offsetLeft + HORIZONTAL_PADDING) * textbox.multiplier, //(left- offsetleft + padding) x multiplier
      y:
        (textbox.pageHeight -
          (textbox.tbTop - textbox.offsetTop) -
          textbox.tbHeight +
          VERTICAL_PADDING_LIST.get(textbox.fontSize)) *
        textbox.multiplier, //(pageheight - (top - offsettop) - height + padding) x multiplier
      size: textbox.fontSize * textbox.multiplier, //font x multiplier
      font: font,
      color: rgb(textbox.color.r / 255, textbox.color.g / 255, textbox.color.b / 255),
      rotate: degrees(0),
    })
  }
}

export const embedImageAndText = async (url, images, textboxes) => {
  try {
    const response = await fetch(url)
    const existingPdfBytes = await response.arrayBuffer()
    const pdfDoc = await PDFDocument.load(existingPdfBytes, {
      ignoreEncryption: true,
      throwOnInvalidObject: true,
    })
    await drawImages(pdfDoc, images)
    await drawTexts(pdfDoc, textboxes)
    const pdfBytes = await pdfDoc.save()
    var blob = new Blob([pdfBytes])
    const result = await getBase64(blob)
    return result
  } catch (error) {
    console.error(error)
    throw new Error(error)
  }
}
